import { render, staticRenderFns } from "./goBack.vue?vue&type=template&id=1b247410&scoped=true"
import script from "./goBack.vue?vue&type=script&lang=js"
export * from "./goBack.vue?vue&type=script&lang=js"
import style0 from "./goBack.vue?vue&type=style&index=0&id=1b247410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b247410",
  null
  
)

export default component.exports